import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import LinkApp from '../views/LinkApp.vue';
import About from '../views/About.vue';
import Search from '../views/Search.vue';
import MakeQuote from '../views/MakeQuote.vue';
import MakeQuoteWithoutAuth from '../views/MakeQuoteWithoutAuth.vue';
import HowParticipate from '../views/HowParticipate.vue';
import CalcCustos from '../views/CalcCustos.vue';
import LinkCadTempo from '../views/LinkCadTempo.vue';
import ShopkeeperSpecialRegister from '../views/ShopkeeperSpecialRegister.vue';
import MenorPreco from '../views/lojista/MenorPreco';
import MenorPrecoCliente from '../views/cliente/MenorPrecoCliente';
import PasswordClerk from '../views/lojista/clerk-app/PasswordClerk.vue';
import ModalApp from '../views/ModalApp.vue';
import NewPassword from '../views/NewPassword';
import SolicitarAppSemLogin from '../views/SolicitarAppSemLogin.vue'
import ShareProductApp from '../views/ShareProductApp'
import OrderDetailsPrint from '../views/OrderPrint.vue';

// Affiliate
import SuccessfullyRegister from '../views/affiliate/SuccessfullyRegister.vue';

/* Páginas de area restrita */
import RestrictedArea from '../views/RestrictedArea.vue';
import ARCadastroGerente from '../views/ARCadastroGerente.vue';
import ARCadastro from '../views/Register.vue';
import ARCadastroLojista from '../views/RegisterLojista.vue';
import ARCadastroLojistaLandingPage from '../views/RegisterLojistaLandingPage.vue';
import UseTerms from '../views/UseTerms.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import LandingPage from '../views/LandingPage.vue';
import Contact from '../views/Contact.vue';
import Redirect from '../views/Redirect.vue';
import LojaVirtualComApp from '../views/LojaVirtualComApp.vue';
import Exit from '../views/Exit.vue';

import Error404 from '../components/Error404.vue';

/*
  Modules
*/
import professionalGuide from './professionalGuide';
import blog from './blog';
import journal from './journal';
import client from './restrictedArea/client';
import balconista from './restrictedArea/balconista';
import gerenteConta from './restrictedArea/gerenteConta';
import partner from './restrictedArea/partner';
import shopkeeper from './restrictedArea/shopkeeper';
import professional from './restrictedArea/professional';
import admin from './restrictedArea/admin';
import representative from './restrictedArea/representative';
import affiliate from './restrictedArea/affiliate';
// import editor from './restrictedArea/editor';

import PaymentsApp from '../views/PaymentsApp.vue';
import CadastroPaymentsAssinatura from '../views/CadastroPaymentsAssinatura.vue';
import CadastroPaymentsAssinaturaProfissional from '../views/CadastroPaymentsAssinaturaProfissional.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/link-app/:id',
      name: 'link-app',
      component: LinkApp,
    },
    {
      path: '/checkout-pagamento/:lojista/:id',
      name: 'checkout-pagamento-construp',
      component: PaymentsApp,
    },
    {
      path: '/cadastro-assinatura/:id',
      name: 'cadastro-pagamento-assinatura',
      component: CadastroPaymentsAssinatura,
    },
    {
      path: '/cadastro-assinatura-profissional/:id',
      name: 'cadastro-pagamento-assinatura-profissional',
      component: CadastroPaymentsAssinaturaProfissional,
    },
    {
      path: '/sobre',
      name: 'sobre',
      component: About,
    },
    {
      path: '/fazer-cotacao',
      name: 'fazer-cotacao',
      component: MakeQuote,
    },
    {
      path: '/fazer-nova-cotacao',
      name: 'fazer-nova-cotacao',
      component: MakeQuoteWithoutAuth,
    },

    {
      path: '/lojista-app',
      name: 'lojista-app',
      component: ModalApp,
    },

    {
      path: '/recupera-senha',
      name: '/recupera-senha',
      component: NewPassword,
    },
    {
      path: '/novo-afiliado',
      name: 'novo-afiliado',
      component: SuccessfullyRegister,
    },
    {
      path: '/pesquisa/:pesq',
      name: 'pesquisa',
      props: true,
      component: Search,
    },
    {
      path: '/quero-vender',
      name: 'quero-vender',
      component: HowParticipate,
    },
    {
      path: '/calculadora-custos',
      name: 'calculadora-custos',
      component: CalcCustos,
    },
    {
      path: '/link-cadastro-tempo',
      name: 'link-cadastro-tempo',
      component: LinkCadTempo,
    },
    ...professionalGuide,
    {
      path: '/termos',
      name: 'termos',
      component: UseTerms,
    },
    {
      path: '/privacidade',
      name: 'privacidade',
      component: PrivacyPolicy,
    },
    {
      path: '/lp',
      name: 'landing-page',
      component: LandingPage,
    },
    {
      path: '/area-restrita',
      name: 'area-restrita',
      component: RestrictedArea,
      children: [
        {
          path: '/area-restrita/cadastro/gerente-conta',
          name: 'cadastro-gerente-conta',
          component: ARCadastroGerente
        },
        {
          path: '/area-restrita/cadastro/:type?',
          name: 'cadastro',
          component: ARCadastro,
          props: true,
        },
        {
          path: '/area-restrita/cadastro-lojista',
          name: 'cadastro-lojista',
          component: ARCadastroLojista,
          props: true,
        },
        {
          path: '/area-restrita/cadastro-demo-lojista',
          name: 'cadastro-demo-lojista',
          component: ARCadastroLojistaLandingPage,
          props: true,
        },
        ...partner,
        ...client,
        ...shopkeeper,
        ...professional,
        ...representative,
        ...admin,
        ...affiliate,
        ...balconista,
        ...gerenteConta
      ],
    },
    ...blog,
    ...journal,
    {
      path: '/contato',
      name: 'contato',
      component: Contact,
    },
    {
      path: '/grupowhats',
      name: 'grupowhats',
      component: Redirect,
    },
    {
      path: '/loja-virtual-com-app',
      name: 'loja-virtual-com-app',
      component: LojaVirtualComApp,
    },
    {
      path: '/sair',
      name: 'sair',
      component: Exit,
    },
    {
      path: '*',
      name: 'error404',
      component: Error404,
    },
    {
      path: '/registro-especial',
      name: 'registro-especial',
      component: ShopkeeperSpecialRegister,
    },
    {
      path: '/menor-preco',
      name: 'menor-preco',
      component: MenorPreco,
    },
    {
      path: '/menor-preco-cliente',
      name: 'menor-preco-cliente',
      component: MenorPrecoCliente,
    },
    {
      path: '/solicitar-app',
      name: 'solicitar-app',
      component: SolicitarAppSemLogin,
    },
    {
      path: '/senha-balconista',
      name: '/senha-balconista',
      component: PasswordClerk,
    },
    {
      path: '/print-order',
      name: 'print-order',
      component: OrderDetailsPrint
    },
    {
      path: '/share-product-app/shopkeeper=:shopkeeper/id=:id',
      name: 'share-product-app',
      component: ShareProductApp
    },
    {
      path: '/admin/impersonate/login',
      name: 'admin-impersonate-login',
      component: () => import('../views/administrador/impersonate/Login.vue'),
    }
  ],
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 100);
    });
  },
});
